import { Web3Provider } from '@ethersproject/providers'
import { useCallback } from 'react'
import { useAppDispatch } from 'store'

import { connectLinkWalletAction } from '../../store/link/actions/connectLinkWalletActions'
import { AccountInterface } from 'starknet'
import { isFulfilled, isRejected } from '@reduxjs/toolkit'

export const useConnectLinkWallet = () => {
  const dispatch = useAppDispatch()
  return useCallback(
    async (provider: Web3Provider | AccountInterface) => {
      const actionResult = await dispatch(
        connectLinkWalletAction({ provider: provider! }),
      )

      if (isFulfilled(actionResult)) {
        return actionResult.payload.signer
      }
      if (isRejected(actionResult)) {
        return Promise.reject(actionResult?.error)
      }

      return undefined
    },
    [dispatch],
  )
}
